(function() {
  async function validateAndMaybeBlock(form, evt) {
    if (!window.InventoryCheck) return true; // fail open

    const variantInput = form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('[name="quantity"]');
    const variantId = parseInt(variantInput?.value, 10);
    const requestedQty = parseInt(qtyInput?.value || '1', 10);

    if (!variantId) return true;

    const check = await window.InventoryCheck.canAddToInventory(variantId, requestedQty);
    console.log('[StockGuard] check:', check);

    if (check.ok) return true;

    const message = check.stock <= 0
      ? 'This product is out of stock.'
      : check.remaining <= 0
        ? `All ${check.stock} units are already in your bucket or cart.`
        : `Only ${check.remaining} left — you already have ${check.committed} in your bucket or cart.`;

    if (typeof alertify !== 'undefined') {
      alertify.error(message);
    } else {
      alert(message);
    }

    // Re-enable any submit buttons
    form.querySelectorAll('[type="submit"]').forEach(btn => {
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading');
    });

    return false;
  }

  function attachToForm(form) {
    if (form.__stockGuardAttached) return;
    form.__stockGuardAttached = true;

    // Capture phase = we run before other listeners, including Shopify's
    form.addEventListener('submit', async function(evt) {
      // Synchronously stop the submit; we'll resubmit if the check passes
      evt.preventDefault();
      evt.stopImmediatePropagation();

      const allowed = await validateAndMaybeBlock(form, evt);
      if (allowed) {
        // Bypass our listener on this submit
        form.__stockGuardAttached = false;
        form.submit(); // native submit, doesn't fire 'submit' event listeners
      }
    }, true);

    console.log('[StockGuard] attached to form', form.action);
  }

  function scanAndAttach() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(attachToForm);
  }

  // Initial scan
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndAttach);
  } else {
    scanAndAttach();
  }

  // Watch for forms added later (variant changes, AJAX-loaded sections, etc.)
  new MutationObserver(() => scanAndAttach())
    .observe(document.documentElement, { childList: true, subtree: true });
})();